<script setup>
import DealerCard from '@/components/cards/DealerCard.vue';
const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
  template: {
    type: String,
    default: () => '',
  },
});

const hoveredCard = ref(null);
const setHoveredCard = (cardId) => {
  hoveredCard.value = cardId;
};

const clearHoveredCard = () => {
  hoveredCard.value = null;
};
const viewMode = computed(() => {
  if (props.template === 'with_strategic') return 'brand-strategic';
  if (props.template === 'banks') return 'banks';
  return 'brand';
});
</script>
<template>
  <ul
    v-if="items"
    class="m-0 p-0 brands__items"
    :class="[
      'm-0 p-0 brands__items',
      {
        'brands__items--with-strategic': template === 'with_strategic',
        'has-hovered-card': hoveredCard !== null,
      },
    ]"
  >
    <li
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
      :class="[
        'm-0 brands__item',
        {
          'brands__item--first': itemIndex === 0,
        },
      ]"
      data-aos="fade-up"
      :data-aos-delay="itemIndex >= 1 ? 100 + 100 * itemIndex : 100"
    >
      <DealerCard
        :view="viewMode"
        :is-first="itemIndex === 0"
        :title="item?.title"
        :logo="item?.logo"
        :url="item?.url"
        :background-color="backgroundColor"
        :class="{
          'is-blurred': hoveredCard !== null && hoveredCard !== itemIndex,
          'is-hovered': hoveredCard === itemIndex,
        }"
        @mouseenter="setHoveredCard(itemIndex)"
        @mouseleave="clearHoveredCard"
      />
    </li>
  </ul>
</template>

<style scoped lang="scss">
@use 'sass:math';
.brands {
  $parent: &;
  &__items {
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(2, 1fr);
    list-style: none;
    @include media-breakpoint-up(sm) {
      grid-template-columns: repeat(4, 3fr);
    }
    @include media-breakpoint-up(md) {
      grid-template-columns: repeat(6, 2fr);
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 8);
    }
    &.has-hovered-card {
      @include media-breakpoint-up(md) {
        :deep(.dealer) {
          transition: all 0.3s ease;
          &.is-blurred {
            opacity: 0.5;
          }
          &.is-hovered {
            opacity: 1;
          }
        }
      }
    }
    &--with-strategic {
      column-gap: 8px;
      row-gap: 24px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(row-gap, 24);
      }
      #{$parent} {
        &__item {
          width: calc(50% - 4px);
          &--first {
            width: 100%;
          }
          @include media-breakpoint-up(sm) {
            width: calc(25% - 8px * 3 / 4);
            &--first {
              width: 100%;
            }
          }
          @include media-breakpoint-up(md) {
            width: calc(16.66% - 8px * 5 / 6);
            &--first {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
